export const ModeAction = {
  ADD: 'add',
  EDIT: 'edit',
  VIEW: 'view',
  SELECTED: 'selected',
  COPY: 'copy',
};
